import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { DropdownMenu } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { moreVertical } from '@wordpress/icons';
export default function MoreMenuDropdown(_ref) {
  let {
    as: DropdownComponent = DropdownMenu,
    className,

    /* translators: button label text should, if possible, be under 16 characters. */
    label = __('Options'),
    popoverProps,
    toggleProps,
    children
  } = _ref;
  return createElement(DropdownComponent, {
    className: classnames('interface-more-menu-dropdown', className),
    icon: moreVertical,
    label: label,
    popoverProps: {
      position: 'bottom left',
      ...popoverProps,
      className: classnames('interface-more-menu-dropdown__content', popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.className)
    },
    toggleProps: {
      tooltipPosition: 'bottom',
      ...toggleProps
    }
  }, onClose => children(onClose));
}
//# sourceMappingURL=index.js.map